import { BaseBlockFormat, ParagraphElement } from 'components/_new/NewSlateEditor/types';

export const createParagraph = (text: string): ParagraphElement => ({
	type: BaseBlockFormat.PARAGRAPH,
	children: [{ text }],
});
